class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", e => "Escape" === e.code && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.paymentOpenTrigger = this.querySelector(".payment-modal-trigger");
    this.paymentCloseTrigger = this.querySelector(".payment-modal-close");
    this.paymentOpenTrigger?.addEventListener("click", e => this.openModal(e.currentTarget));
    this.paymentCloseTrigger?.addEventListener("click", e => this.closeModal(e.currentTarget));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const e = document.querySelector("#cart-icon-bubble");
    if (!e) return;
    e.setAttribute("role", "button");
    e.setAttribute("aria-haspopup", "dialog");
    e.addEventListener("click", t => { t.preventDefault(); this.open(e); });
    e.addEventListener("keydown", t => { if ("SPACE" === t.code.toUpperCase()) { t.preventDefault(); this.open(e); } });
  }

  openModal(e) {
    if (!e) return;
    const t = e.closest(".handypay-installment-wrapper");
    if (!t) return;
    t.querySelector(".handypay-modal").classList.toggle("hidden");
  }

  closeModal(e) {
    if (!e) return;
    const t = e.closest(".handypay-installment-wrapper");
    if (!t) return;
    t.querySelector(".handypay-modal").classList.toggle("hidden");
  }

  open(e) {
    e && this.setActiveElement(e);
    const t = this.querySelector('[id^="Details-"] summary');
    t && !t.hasAttribute("role") && this.setSummaryAccessibility(t);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const e = this.classList.contains("is-empty")
        ? this.querySelector(".drawer__inner-empty")
        : document.getElementById("CartDrawer");
      const t = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(e, t);
    }, { once: true });

    // Replaced overflow-hidden on body/html with drawer-open on body only.
    // scrollbar-gutter: stable in CSS keeps the scrollbar space reserved so no layout shift occurs.
    document.body.classList.add("drawer-open");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("drawer-open");
  }

  setSummaryAccessibility(e) {
    e.setAttribute("role", "button");
    e.setAttribute("aria-expanded", "false");
    e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id);
    e.addEventListener("click", e => {
      e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
    });
    e.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(e) {
    this.classList.remove("is-empty");
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = e.id;
    this.getSectionsToRender().forEach(t => {
      const r = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
      r && (r.innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector));
    });
    this.paymentOpenTrigger = this.querySelector(".payment-modal-trigger");
    this.paymentCloseTrigger = this.querySelector(".payment-modal-close");
    this.paymentOpenTrigger?.addEventListener("click", e => this.openModal(e.currentTarget));
    this.paymentCloseTrigger?.addEventListener("click", e => this.closeModal(e.currentTarget));
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" }
    ];
  }

  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }

  setActiveElement(e) {
    this.activeElement = e;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" }
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);